import apiBaseState from "~/constants/apiBaseState";
import getAiTaskProjectMessage from "~/utils/getAiTaskProjectMessage";
const getState = () => {
    return {
        createMediaAnalyserRecordState: apiBaseState(),
        updateMediaAnalyserRecordState: apiBaseState(),
        deleteMediaAnalyserRecordState: apiBaseState(),
        mediaAnalyserRecordState: apiBaseState(),
        mediaAnalyserRecordsState: apiBaseState(),
        retryIngestionState: apiBaseState(),
        mediaAnalyserStatsState: apiBaseState(),
        currentRecord: null,
        mediaRecord: null,
    };
};
export const getters = {
    aiProjectEnabled(state, getters, rootState){
        return rootState.webGeneral.project?.data?.ai_analysis_enabled;
    },
    aiTaskEnabled(state, getters, rootState){
        return rootState.webTask.taskSetupState?.data.ai_analysis_enabled;
    },
    isAiEnabled(state, getters, rootState){
        return rootState.webGeneral.project?.data?.ai_analysis_enabled && rootState.webTask.taskSetupState?.data?.ai_analysis_enabled;
    },
    aiDisabledMessage(state, getters, rootState){
        return getAiTaskProjectMessage({
            aiProjectEnabled: rootState.webGeneral.project?.data?.ai_analysis_enabled,
            aiTaskEnabled: rootState.webTask.taskSetupState?.data.ai_analysis_enabled,
            type: 2
        });
    },
};

export const state = () => (getState());
export const mutations = {
    RESET_STORE(state){
        const s = getState();
        Object.keys(s).forEach(key => {
            if(key !== 'mediaAnalyserRecordsState'){
                state[key] = s[key];
            }
        });
    },
    SET_MEDIA_AI_RECORD_RETRY_INGESTION(state, payload){
        state.retryIngestionState = payload;
    },
    SET_GET_MEDIA_AI_RECORD(state, payload){
        state.mediaAnalyserRecordState = payload;
    },
    SET_MEDIA_ANALYSER_RECORD_ID(state, payload){
        state.currentRecord = payload;
    },
    SET_MEDIA_ANALYSER_RECORD(state, payload){
        state.mediaRecord = payload;
    },
    SET_CREATE_MEDIA_AI_RECORD(state, payload){
        state.createMediaAnalyserRecordState = payload;
    },
    SET_UPDATE_MEDIA_AI_RECORD(state, payload){
        state.updateMediaAnalyserRecordState = payload;
    },
    SET_DELETE_MEDIA_AI_RECORD(state, payload){
        state.deleteMediaAnalyserRecordState = payload;
    },
    SET_MEDIA_AI_RECORDS(state, payload){
        state.mediaAnalyserRecordsState = payload;
    },
    ADD_TO_MEDIA_AI_RECORDS(state, payload){
        state.mediaAnalyserRecordsState.data.data.unshift(payload);
    },
    UPDATE_MEDIA_AI_RECORDS(state, payload){
        if(state.mediaAnalyserRecordsState.data){
            const index = state.mediaAnalyserRecordsState.data.data.findIndex(item => item.id === payload.id);
            state.mediaAnalyserRecordsState.data.data.splice(index, 1, payload);
        }
    },
    UPDATE_MEDIA_AI_RECORDS_STATUS(state, {status, id}){
        if(state.mediaAnalyserRecordsState.data){
            const index = state.mediaAnalyserRecordsState.data.data.findIndex(item => item.id === id);
            state.mediaAnalyserRecordsState.data.data[index].status = status;
        }
    },
    DELETE_MEDIA_AI_RECORDS(state, payload){
        const index = state.mediaAnalyserRecordsState.data.data.findIndex(item => item.id === payload.id);
        state.mediaAnalyserRecordsState.data.data.splice(index, 1);
    },
    MARK_RECORD_FOR_DELETION(state, payload){
        const index = state.mediaAnalyserRecordsState.data.data.findIndex(item => item.id === payload.id);
        const record = state.mediaAnalyserRecordsState.data.data[index];
        state.mediaAnalyserRecordsState.data.data[index] = {
            ...record,
            isDeleted: true
        };
    },
    SET_MEDIA_AI_STATS(state, payload){
        state.mediaAnalyserStatsState = payload;
    },
};

export const actions = {
    GET_MEDIA_AI_STATS(state, data) {
        const {accountSlug, projectSlug, taskSlug} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/insight-assist/ai`;

        return this.$whyApi.get({
            url,
            mutation: "mediaAnalyser/SET_MEDIA_AI_STATS",
            errorMessage: "Error getting media stats",
            notify: this.$notify
        });
    },
    GET_MEDIA_AI_RECORD(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...rest} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/insight-assist/${rest.id}`;

        return this.$whyApi.get({
            url,
            mutation: "mediaAnalyser/SET_GET_MEDIA_AI_RECORD",
            errorMessage: "Error getting media record",
            notify: this.$notify
        });
    },
    DELETE_MEDIA_AI_RECORD(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...rest} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/insight-assist/${rest.id}`;

        return this.$whyApi.delete({
            url,
            mutation: "mediaAnalyser/SET_DELETE_MEDIA_AI_RECORD",
            errorMessage: "Error updating media record",
            notify: this.$notify
        });
    },
    UPDATE_MEDIA_AI_RECORD(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...rest} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/insight-assist/${rest.id}`;

        return this.$whyApi.put({
            url,
            data: rest,
            mutation: "mediaAnalyser/SET_UPDATE_MEDIA_AI_RECORD",
            errorMessage: "Error updating media record",
            notify: this.$notify
        });
    },
    MEDIA_AI_RECORD_RETRY_INGESTION({state, commit}, data) {
        const {accountSlug, projectSlug, taskSlug, ...rest} = data;
        commit('UPDATE_MEDIA_AI_RECORDS_STATUS', {id: rest.id, status: 'PENDING'});
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/insight-assist/${rest.id}/retry-ingestion`;

        return this.$whyApi.post({
            url,
            data: rest,
            mutation: "mediaAnalyser/SET_MEDIA_AI_RECORD_RETRY_INGESTION",
            errorMessage: "Error retrying analysing media record",
            notify: this.$notify
        });
    },
    CREATE_MEDIA_AI_RECORD(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...rest} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/insight-assist`;

        return this.$whyApi.post({
            url,
            data: rest,
            handleMedia: true,
            useProgressIndicator: true,
            mutation: "mediaAnalyser/SET_CREATE_MEDIA_AI_RECORD",
            errorMessage: "Error creating media record",
            notify: this.$notify
        });
    },
    GET_MEDIA_AI_RECORDS(state, data) {
        const {accountSlug, projectSlug, taskSlug, apiQuery} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/insight-assist`;

        return this.$whyApi.get({
            url,
            params: apiQuery,
            mutation: "mediaAnalyser/SET_MEDIA_AI_RECORDS",
            errorMessage: "Error getting media records",
            notify: this.$notify
        });
    },
    INITIALISE_PUSHER_LISTENER({state, commit, rootState}, $echo) {
        if (!rootState.auth.user) return;
        const channel = `App.User.${rootState.auth.user.id}`;
        $echo.private(channel).listen(".InsightAssist", (data) => {
            commit('UPDATE_MEDIA_AI_RECORDS_STATUS', {id: data.model_id, status: data.status});
        });
    },
};
